import { Components, Theme } from '@mui/material/styles';
// Layout belongs to the containing Stack/Grid, not hidden field margins.
// Helper text stays in normal flow so long validation errors never overlap.
export const MuiFormControl: Components<Theme>['MuiFormControl'] = {
  styleOverrides: { root: { marginBottom: 0 } },
};
export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    outlined: ({ theme }) => ({
      position: 'relative',
      transform: 'none',
      marginBottom: 5,
      fontSize: 13,
      lineHeight: '20px',
      fontWeight: 500,
      color: theme.palette.text.secondary,
      '&.Mui-focused': { color: theme.palette.primary.main },
      '&.Mui-error': { color: theme.palette.error.main },
    }),
  },
};
export const MuiFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: { margin: '4px 0 0', fontSize: 12, lineHeight: 1.5 },
  },
};
